import _export from '../internals/export.js';
import createHtml from '../internals/create-html.js';
import stringHtmlForced from '../internals/string-html-forced.js';

var $ = _export;
var createHTML = createHtml;
var forcedStringHTMLMethod = stringHtmlForced; // `String.prototype.fontcolor` method
// https://tc39.es/ecma262/#sec-string.prototype.fontcolor

$({
  target: 'String',
  proto: true,
  forced: forcedStringHTMLMethod('fontcolor')
}, {
  fontcolor: function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  }
});
